// extracted by mini-css-extract-plugin
export var appContainer = "MobileWebBanner_appContainer__mFz5v";
export var container = "MobileWebBanner_container__5KCQu";
export var dbClose = "MobileWebBanner_dbClose__5p+EY";
export var dbCloseIcon = "MobileWebBanner_dbCloseIcon__3-SxL";
export var description = "MobileWebBanner_description__FP7-Q";
export var details = "MobileWebBanner_details__Siomm";
export var logoImage = "MobileWebBanner_logoImage__s666R";
export var openButton = "MobileWebBanner_openButton__+dx3+";
export var title = "MobileWebBanner_title__TD7Ue";